import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import { logger } from "../utils/logging"

export const defaultNamespace = "default"
export const i18n = i18next.use(initReactI18next)

i18n.init({
  fallbackLng: "en",
  defaultNS: defaultNamespace,
  partialBundledLanguages: true,
  resources: {},
  interpolation: {
    // react is already safe from xss => https://www.i18next.com/translation-function/interpolation#unescape
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
})

export async function loadLocaleResources(language: string, organizationHumanReadableId?: string) {
  const defaultLocales = await import(`./locales/${language}/default.json`)
  // https://www.i18next.com/overview/api#addresourcebundle
  i18n.addResourceBundle(language, defaultNamespace, defaultLocales, true, true)

  if (organizationHumanReadableId !== undefined) {
    try {
      const organizationLocales = await import(`./locales/${language}/${organizationHumanReadableId}.json`)
      i18n.addResourceBundle(language, defaultNamespace, organizationLocales, true, true)
    } catch {
      logger.debug(`No organization locales found for ${language} and ${organizationHumanReadableId}`)
    }
  }
}
